import { useMutation, useQueryClient } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import mutationRemodelBuildingModel from "ApiLayer/Building/mutationRemodelBuildingModel";

export const useRemodelBuildingModel = (onSuccess?: () => void) => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const alert = useAlert();

    return useMutation({
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["report"],
            });
            queryClient.invalidateQueries({
                queryKey: ["buildingModelsTable"],
            });
            alert.success("Your building has been remodelled. Please wait a few seconds.");

            if (onSuccess) onSuccess();
        },
        onError: (error: Error) => {
            alert.error(error.message);
        },
        mutationFn: async (buildingModelUids: string[]) => mutationRemodelBuildingModel(accessToken, buildingModelUids),
    });
};
